import { ChevronLeft, ChevronRight, Calendar } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { format, subDays, addDays, isToday, isSameDay } from 'date-fns';

interface WhoopDayNavigatorProps {
  selectedDate: Date;
  onDateChange: (date: Date) => void;
  minDate?: Date;
}

export default function WhoopDayNavigator({ selectedDate, onDateChange, minDate }: WhoopDayNavigatorProps) {
  const canGoForward = !isToday(selectedDate);
  const canGoBack = !minDate || selectedDate > minDate;

  const goToPrevious = () => {
    if (canGoBack) {
      onDateChange(subDays(selectedDate, 1));
    }
  };

  const goToNext = () => {
    if (canGoForward) {
      onDateChange(addDays(selectedDate, 1));
    }
  };

  const goToToday = () => {
    onDateChange(new Date());
  };

  return (
    <div className="flex items-center justify-center gap-1 sm:gap-2 p-2 sm:p-3 bg-secondary/5 rounded-lg border border-secondary/20">
      <Button
        variant="ghost"
        size="icon"
        onClick={goToPrevious}
        disabled={!canGoBack}
        className="h-8 w-8 shrink-0"
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>

      <div className="flex items-center gap-1.5 sm:gap-2 min-w-0 justify-center flex-1">
        <Calendar className="h-4 w-4 text-primary shrink-0" />
        <span className="font-medium text-foreground text-sm sm:text-base truncate">
          {isToday(selectedDate) 
            ? 'Today' 
            : format(selectedDate, 'EEE, MMM d')}
        </span>
      </div>

      <Button
        variant="ghost"
        size="icon"
        onClick={goToNext}
        disabled={!canGoForward}
        className="h-8 w-8 shrink-0"
      >
        <ChevronRight className="h-4 w-4" />
      </Button>

      {!isToday(selectedDate) && (
        <Button
          variant="outline"
          size="sm"
          onClick={goToToday}
          className="ml-1 sm:ml-2 text-xs shrink-0"
        >
          Today
        </Button>
      )}
    </div>
  );
}
